import { GET_RECON_PREVIEW, GET_RECON_PREVIEW_SUCCESS, GET_RECON_PREVIEW_ERROR, GET_RECON_PREVIEW_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetReconPreview = (state = initialState, action) => {
  switch (action.type) {
    case GET_RECON_PREVIEW:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_RECON_PREVIEW_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_RECON_PREVIEW_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_RECON_PREVIEW_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetReconPreview;
